import i18n from '../../i18n/i18n';

const data = {
  vi: {
    promise: {
      title: "Our Promise – Lời hứa của AuraGlow",
      description:
        "Ra đời với sứ mệnh giúp chị em phụ nữ xây dựng ý thức chăm sóc da bền vững, để việc chăm da không còn là một thói quen ngắn hạn, mà trở thành một lối sống lành mạnh giúp kéo dài tuổi thọ của làn da.\n\nChúng tôi tin rằng vẻ đẹp thật sự khởi nguồn từ một làn da khỏe mạnh, và sự kết hợp hài hòa giữa thiên nhiên và khoa học mới tạo nên kết quả bền vững.\n\nMỗi sản phẩm AuraGlow đều được đưa vào các thành phần được nghiên cứu và có bằng chứng khoa học rõ ràng, mang lại làn da khỏe mạnh, căng mọng và trẻ trung hơn mỗi ngày.\n\nAuraGlow cam kết sử dụng nguồn nguyên liệu tự nhiên, công nghệ sinh học tiên tiến, tuân thủ tiêu chuẩn quốc tế và hoàn toàn không thử nghiệm trên động vật.\n\nChúng tôi mong muốn trở thành người bạn đồng hành, giúp bạn chăm sóc - nuôi dưỡng - phục hồi làn da một cách tự nhiên và bền vững.",
    },
    values: {
      title: "Our Values – Giá trị thương hiệu",
      description:
        "Vì làn da chính là tấm gương phản chiếu sức khỏe thể chất và cảm xúc bên trong, AuraGlow tin rằng chăm sóc da cũng chính là chăm sóc bản thân một cách toàn diện.\n\nMỗi công thức của chúng tôi được tạo nên để khôi phục sự cân bằng tự nhiên của làn da, đồng thời các nghi thức chăm sóc được thiết kế để mang lại sự tự tin, niềm vui và cảm giác thư thái.\n\nChăm sóc da không chỉ là một việc cần làm mỗi ngày – mà là khoảnh khắc bạn lắng nghe chính mình, cảm nhận sự kết nối giữa làn da, cơ thể và tâm trí.",
    },
    partners: [
      {
        description:
          "Giáo sư Jeffrey Goldman là một chuyên gia có tiếng về da liễu và hóa mỹ phẩm tại Mỹ. Ông tốt nghiệp Đại học Stanford, từng giữ vị trí quan trọng tại Procter & Gamble – tập đoàn mỹ phẩm lớn hàng đầu thế giới, nơi ông tham gia nghiên cứu công thức và đánh giá hiệu quả của các hoạt chất chăm sóc da thế hệ mới.\n\nVới hơn 30 năm cống hiến cho khoa học, Giáo sư Goldman đã thực hiện nhiều đề tài nghiên cứu có giá trị lớn về cơ chế tái tạo da, sửa chữa tổn thương vi mô và tối ưu khả năng hấp thụ dưỡng chất. Các công trình của ông được giới chuyên môn đánh giá cao và đang được ứng dụng rộng rãi trong thực hành lâm sàng cũng như trong ngành chăm sóc da chuyên sâu.\n\nÔng chính là người đặt nền tảng khoa học cho bộ sản phẩm lăn kim AuraGlow, giúp mang lại hiệu quả trẻ hóa sâu và an toàn cho người dùng ngay tại nhà.",
      },
    ],
  },
  en: {
    promise: {
      title: "Our Promise – The Promise of AuraGlow",
      description:
        "Born with the mission to help women build sustainable skincare awareness, so that skincare is no longer a short-term habit but becomes a healthy lifestyle that extends the longevity of your skin.\n\nWe believe true beauty originates from healthy skin, and the harmonious combination of nature and science creates lasting results.\n\nEvery AuraGlow product incorporates scientifically researched and clinically proven ingredients, delivering healthier, plumper, and more youthful skin every day.\n\nAuraGlow is committed to using natural ingredients, advanced biotechnology, adhering to international standards, and being completely cruelty-free.\n\nWe aspire to be your trusted companion, helping you care for, nourish, and restore your skin naturally and sustainably.",
    },
    values: {
      title: "Our Values – Brand Values",
      description:
        "Because skin is a mirror reflecting physical health and inner emotions, AuraGlow believes that skincare is also holistic self-care.\n\nEach of our formulas is created to restore the skin's natural balance, while skincare rituals are designed to bring confidence, joy, and relaxation.\n\nSkincare is not just a daily task – it's a moment to listen to yourself and feel the connection between your skin, body, and mind.",
    },
    partners: [
      {
        description:
          "Professor Jeffrey Goldman is a renowned expert in dermatology and cosmetic chemistry in the United States. A Stanford University graduate, he held key positions at Procter & Gamble – one of the world's largest cosmetics corporations, where he participated in formula research and evaluation of next-generation skincare active ingredients.\n\nWith over 30 years of dedication to science, Professor Goldman has conducted numerous high-value research on skin regeneration mechanisms, micro-damage repair, and optimizing nutrient absorption. His work is highly regarded by professionals and widely applied in clinical practice and advanced skincare.\n\nHe is the one who laid the scientific foundation for AuraGlow's microneedling product line, delivering deep rejuvenation effects safely for at-home use.",
      },
    ],
  },
};

export const getOurStoryData = () => {
  const lang = i18n.language?.startsWith('en') ? 'en' : 'vi';
  const localized = data[lang];

  return {
    banner: "https://res.cloudinary.com/degewiqpj/image/upload/v1773900691/Banner_%C4%91%E1%BA%A7u_trang_1_wxjext.jpg",
    promise: {
      title: localized.promise.title,
      description: localized.promise.description,
      image: "https://res.cloudinary.com/degewiqpj/image/upload/v1773899765/Our_Promise_schqnh.png"
    },
    values: {
      title: localized.values.title,
      description: localized.values.description,
      image: "https://res.cloudinary.com/dzqgh7xfd/image/upload/v1775706919/Our_Value_qrkkoh.png"
    },
    founder: {
      name: "Mr. Jeffrey Goldman",
      role: "Giáo sư Viện nghiên cứu Procter & Gamble",
      description: localized.partners[0].description,
      image: "https://res.cloudinary.com/degewiqpj/image/upload/v1773900195/Mr._Jeffrey_Goldman_wk53vc.png"
    },
    partners: [
      {
        name: "Mrs. Christine Kim",
        role: "",
        description: "",
        image: "https://res.cloudinary.com/degewiqpj/image/upload/v1773900185/Mrs._Christine_Kim_vvp4sp.jpg"
      },
      {
        name: "Mrs. Sarah Nguyễn",
        role: "",
        description: "",
        image: "https://res.cloudinary.com/degewiqpj/image/upload/v1773900198/Mrs._Sarah_Nguy%E1%BB%85n_bwbepv.jpg"
      },
      {
        name: "Mrs. Annie Lê",
        role: "",
        description: "",
        image: "https://res.cloudinary.com/dzqgh7xfd/image/upload/v1775707614/Mrs_Annie_Le_t0c7ce.jpg"
      }

    ],
    footerImage: "https://res.cloudinary.com/difvdzr4l/image/upload/v1774192022/science1_hqrie9.png"
  };
};
